import { useState, useEffect, useCallback } from "react";
import "./ScrollToTop.css";

export default function ScrollToTopBtn() {
  const [visible, setVisible] = useState(false);
  const [animating, setAnimating] = useState(false);

  const onScroll = useCallback(() => {
    // Check both window and any scrollable container
    const scrollY = window.scrollY
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;

    // Also check common scrollable containers in your app
    const mainEl = document.querySelector(".jp-main")
      || document.querySelector(".main-content")
      || document.querySelector("main");

    const containerScroll = mainEl ? mainEl.scrollTop : 0;

    setVisible(scrollY > 300 || containerScroll > 300);
  }, []);

  useEffect(() => {
    // Listen on window
    window.addEventListener("scroll", onScroll, { passive: true });

    // Also listen on scrollable containers
    const containers = [
      document.querySelector(".jp-main"),
      document.querySelector(".main-content"),
      document.querySelector("main"),
    ].filter(Boolean);

    containers.forEach(el =>
      el.addEventListener("scroll", onScroll, { passive: true })
    );

    return () => {
      window.removeEventListener("scroll", onScroll);
      containers.forEach(el => el.removeEventListener("scroll", onScroll));
    };
  }, [onScroll]);

  // Re-attach listeners when route changes (DOM updates)
  useEffect(() => {
    const timer = setTimeout(() => {
      const containers = [
        document.querySelector(".jp-main"),
        document.querySelector(".main-content"),
        document.querySelector("main"),
      ].filter(Boolean);

      containers.forEach(el =>
        el.addEventListener("scroll", onScroll, { passive: true })
      );

      return () => {
        containers.forEach(el => el.removeEventListener("scroll", onScroll));
      };
    }, 500);

    return () => clearTimeout(timer);
  });

  const handleClick = () => {
    if (animating) return;
    setAnimating(true);

    // Scroll window
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Also scroll any scrollable containers
    const containers = [
      document.querySelector(".jp-main"),
      document.querySelector(".main-content"),
      document.querySelector("main"),
    ].filter(Boolean);

    containers.forEach(el => el.scrollTo({ top: 0, behavior: "smooth" }));

    setTimeout(() => setAnimating(false), 800);
  };

  return (
    <button
      className={`sttb${visible ? " sttb--visible" : ""}${animating ? " sttb--animating" : ""}`}
      onClick={handleClick}
      aria-label="Scroll to top"
      title="Back to top"
    >
      {/* Pulse rings */}
      <span className="sttb__ring sttb__ring--1" />
      <span className="sttb__ring sttb__ring--2" />

      {/* Icon + flame */}
      <span className="sttb__icon-wrap">
        <svg
          className="sttb__arrow"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="20"
          height="20"
        >
          <path d="M12 19V5" />
          <polyline points="5 12 12 5 19 12" />
        </svg>

        <svg
          className="sttb__flame"
          viewBox="0 0 24 24"
          fill="none"
          width="14"
          height="14"
        >
        </svg>
      </span>

    </button>
  );
}